<template>
    <van-popup v-model:show="show" position="bottom" :style="{
        minWidth: '100%',
        minHeight: '100%',
        background: 'rgb(9, 15, 31)'
    }">
        <div class="name_pop">
            <van-row class="title">
                <van-col span="22" style="display: flex; justify-content: center; align-items: center;">
                    {{ $t('profile.withdrawalInfo') }}
                </van-col>
                <van-col span="2">
                    <img src="@/assets/profile/cs_close_n.png" alt="" @click="close">
                </van-col>
            </van-row>

            <div class="content">
                 <DataField :labelText="$t('profile.name')"
                    :content="userStore.withdrawSetting.userName ? userStore.withdrawSetting.userName : '- -'"
                    :leftImage='iconImages[0].img' />
                <DataField :labelText="$t('profile.phoneNum')"
                    :content="userStore.withdrawSetting.phone ? userStore.withdrawSetting.phone : '- -'"
                    :leftImage="iconImages[1].img" />
                <DataField :labelText="$t('profile.email')"
                    :content="userStore.withdrawSetting.email ? userStore.withdrawSetting.email : '- -'"
                    :leftImage="iconImages[2].img" />
                <DataField :labelText="$t('profile.cpfId')"
                    :content="userStore.withdrawSetting.cpf ? userStore.withdrawSetting.cpf : '- -'"
                    :leftImage="iconImages[3].img" />
                <DataField :labelText="$t('profile.cnpj')"
                    :content="userStore.withdrawSetting.cnpj ? userStore.withdrawSetting.cnpj : '- -'"
                    :leftImage="iconImages[3].img" />
            </div>
        </div>

    </van-popup>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import DataField from './dataField.vue'
import { ICON_IMG } from '@/view/profile/supportScript'
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()
const show = ref(false)
const iconImages = ref(ICON_IMG)
const open = () => {
    show.value = true
}

const close = () => {
    show.value = false
}

defineExpose({
    open,
})

</script>
<style scoped>
.van-popup {
   -ms-overflow-style: none;
   scrollbar-width: none;
   overflow-y: auto;
    border-top-left-radius: 0rem !important;
    border-top-right-radius: 0rem !important;
    border: 1px solid rgba(255, 255, 255, 0.10) !important;
    box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.25), inset 0 1px 0 0 rgba(255, 255, 255, .25) !important;
    backdrop-filter: blur(20px) !important;
    height: 100vh;
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.title {
    padding: 10px 10px;
    font-size: 14px;
    background: #101423 !important;
    color: #ffff;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
}

.title img {
    width: 25px;
    padding-top: 5px;
        opacity: 0.6;
}

.van-overlay {
    background-color: rgb(9, 15, 31)
}


.content {
    padding: 10px 15px;
    background: #101629; 
    border-radius: 12px; 
    overflow: hidden;   
    margin: 15px;
}

.label {
    font-size: 14px;
    color: #0167ca;
}

.btn_container {
    padding: 30px 70px;
}

</style>